import { LessonPassport, LessonPassportFooter, LessonPassportHeader } from 'platform-components/common';
import React, { ReactElement } from 'react';

import { SPEC_COURSE_LESSON_STATUS } from 'common.components/spec-course/typings';

import { SpecCourseLessonViewPassportDates } from '../__passport-dates/spec-course-lesson-view__passport-dates';
import { SpecCourseLessonViewPassportStatus } from '../__passport-status/spec-course-lesson-view__passport-status';

import './spec-course-lesson-view__passport.scss';

interface Props {
    beginDate: Date | null;
    endDate: Date | null;
    footer: ReactElement;
    isSkeleton: boolean;
    name: string | null;
    status: SPEC_COURSE_LESSON_STATUS;
}

export const SpecCourseLessonViewPassport = React.memo((props: Props) => {
    const { beginDate, endDate, footer, isSkeleton, name, status } = props;

    return (
        <LessonPassport isSkeleton={isSkeleton} mix="spec-course-lesson-view__passport">
            <LessonPassportHeader>{name}</LessonPassportHeader>
            <SpecCourseLessonViewPassportDates beginDate={beginDate} endDate={endDate} />
            <SpecCourseLessonViewPassportStatus status={status} />
            <LessonPassportFooter>{footer}</LessonPassportFooter>
        </LessonPassport>
    );
});
